import type { ReactNode } from "react";
import React, { useContext, createContext } from "react";
export interface ActiveWorkflowLoadingState {
    isLoading: boolean;
    loadingError: Error | null;
}
const activeWorkflowLoadingStateContext = createContext<ActiveWorkflowLoadingState | null>(null);
export function ActiveWorkflowLoadingStateProvider({ activeWorkflowLoadingState, children }: {
    activeWorkflowLoadingState: ActiveWorkflowLoadingState;
    children: ReactNode;
}) {
    return <activeWorkflowLoadingStateContext.Provider value={activeWorkflowLoadingState}>{children}</activeWorkflowLoadingStateContext.Provider>;
}
export function useActiveWorkflowLoadingState() {
    const activeWorkflowLoadingState = useContext(activeWorkflowLoadingStateContext);
    if (activeWorkflowLoadingState === null) {
        throw new Error("Can't find active workflow loading state context");
    }
    return activeWorkflowLoadingState;
}
